// extracted by mini-css-extract-plugin
export var billingAddress = "_xi-g";
export var contactInfo = "_xi-d";
export var customerInfoContainer = "_xi-c";
export var customerInfoContainerMobile = "_xi-h";
export var customerInfoRow = "_xi-a";
export var customerInfoSection = "_xi-b";
export var fullWidthDividerMobile = "_xi-i";
export var imageContainer = "_xi-1";
export var paymentMethod = "_xi-e";
export var priceText = "_xi-6";
export var priceTextMobile = "_xi-7";
export var product = "_xi-0";
export var productImage = "_xi-2";
export var productInfo = "_xi-4";
export var productMobile = "_xi-9";
export var productTitle = "_xi-8";
export var quantityBadge = "_xi-3";
export var quantityText = "_xi-5";
export var shippingAddress = "_xi-f";